module.exports = __webpack_public_path__ + "img/card-09.7aac4b46.png";